import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCrown } from "@fortawesome/free-solid-svg-icons";
import { jerarquizarSintomaAcupuntura } from "../../../../../state/sintomaAcupuntura/actions";
import { useDispatch } from "react-redux";

const Jerarquico = ({ item }) => {
  const [pin, setPin] = useState(item.jerarquizado);
  const dispatch = useDispatch();
  return (
    <Button
      variant="default"
      data-toggle="tooltip"
      data-placement="top"
      title={pin ? "Desanclar" : "Jerarquización"}
      onClick={() => {
        dispatch(jerarquizarSintomaAcupuntura(item, pin));
        setPin(!pin);
      }}
    >
      <FontAwesomeIcon icon={faCrown} color={pin ? "green" : "black"} />
    </Button>
  );
};

export default Jerarquico;
